<template>
  <div :class="$style.container">
    <img :src="user.photoUrl" alt="" />

    <router-link
      :class="$style.logout"
      to="/logout">
      <font-awesome-icon :icon="faSignOut" />
    </router-link>

    <router-link
      :class="[$style.notifications, {[$style.unread]: hasUnreadNotifications}]"
      to="/notifications"
      v-if="hasNav">
      <template v-if="hasUnreadNotifications">{{unreadNotifications.length}}</template>
      <font-awesome-icon v-else :icon="faBell" />
    </router-link>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  import { faBell } from '@fortawesome/pro-light-svg-icons/faBell'
  import { faSignOut } from '@fortawesome/pro-light-svg-icons/faSignOut'
  import store from '@/lib/store'

  export default {
    components: {
      FontAwesomeIcon
    },
    props: [
      'hasNav'
    ],
    data () {
      return {
        faBell,
        faSignOut,
        user: store.get('user')
      }
    },
    computed: {
      ...mapGetters([
        'unreadNotifications',
        'hasUnreadNotifications'
      ])
    }
  }
</script>

<style module lang="less" src="./user-info.less"></style>



// WEBPACK FOOTER //
// user-info.vue?4ba314f3